import { render, staticRenderFns } from "./VendorCategory.vue?vue&type=template&id=3f55b1c5&scoped=true&"
import script from "./VendorCategory.vue?vue&type=script&lang=js&"
export * from "./VendorCategory.vue?vue&type=script&lang=js&"
import style0 from "./VendorCategory.vue?vue&type=style&index=0&id=3f55b1c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f55b1c5",
  null
  
)

export default component.exports